import { useMutation } from 'react-query';

import { ForumPostSuperPin, adminSuperPin } from '../utils/backend-api/forumPosts';

export default function useForumPostSuperPin() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (values: ForumPostSuperPin) => adminSuperPin(values)
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
